import { observer } from 'mobx-react-lite'
import { Error } from 'shared/ui'
import { ToggleChipGroup } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/ui/ToggleChipGroup/ToggleChipGroup'
import type { GoogleCalendarPickerStore } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/googleCalendarPickerStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/styles.module.scss'

type IBookingStepAvailabilityDaysProps = {
  googleCalendarPickerStore: GoogleCalendarPickerStore
}

export const BookingStepAvailabilityDays = observer(
  ({ googleCalendarPickerStore }: IBookingStepAvailabilityDaysProps) => {
    const {
      availabilityDaysOrder,
      availabilityDays,
      getAvailabilityDayLabel,
      toggleAvailabilityDay,
      availabilityDaysError,
    } = googleCalendarPickerStore

    return (
      <div className={styles.list}>
        <ToggleChipGroup
          items={availabilityDaysOrder}
          columns={7}
          isActive={(day) => availabilityDays.has(day)}
          getLabel={getAvailabilityDayLabel}
          onToggle={toggleAvailabilityDay}
        />
        <Error type={'text'} error={availabilityDaysError} />
      </div>
    )
  }
)
